import React from "react";

import {
  TitleTypography,
  SynopsisTypography,
  ShowActionsContainer,
  MaxWidthContainer,
  ShowDetailsContainer,
  PriorityTypography,
} from "./ShowHeroDetails.styles";
import { Button } from "../";
import Link from "next/link";

export interface CustomShowHeroDetailsProps {
  showTitle?: string | null;
  showSynopsis?: string | null;
  isPriority?: boolean;
}

export const ShowHeroDetails = ({
  showTitle = null,
  showSynopsis = null,
  isPriority = false,
  ...rest
}: CustomShowHeroDetailsProps) => {
  return (
    <ShowDetailsContainer {...rest}>
      <MaxWidthContainer>
        {isPriority && (
          <PriorityTypography>✨Get Priority Entry!✨</PriorityTypography>
        )}
        <TitleTypography data-cy="show-name">{showTitle}</TitleTypography>
        <SynopsisTypography component="pre" data-cy="show-synopsis">
          {showSynopsis}
        </SynopsisTypography>
        <ShowActionsContainer>
          <Link href="#more-info">
            <Button onClick={() => {}} variant="secondary">
              More Show Info
            </Button>
          </Link>
        </ShowActionsContainer>
      </MaxWidthContainer>
    </ShowDetailsContainer>
  );
};

export interface ShowHeroDetailsProps
  extends React.ComponentProps<typeof ShowHeroDetails> {
  as?: React.ElementType;
}

ShowHeroDetails.displayName = "ShowHeroDetails";
